import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from '@material-ui/core';
import React, { memo } from 'react';
import { texts } from '../constants/texts';

export const HelpDialog = memo(
  ({
    mouseActions,
    keyboardActions,
    open,
    onClose
  }: Readonly<{
    mouseActions: [string | JSX.Element, string][];
    keyboardActions: [string | JSX.Element, string][];
    open: boolean;
    onClose: () => void;
  }>) => (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{texts.helpDialog.title}</DialogTitle>
      <DialogContent>
        <Typography variant='h6'>{texts.helpDialog.mouseActions}</Typography>
        <Table>
          <TableBody>
            {mouseActions.map(([action, description], index) => (
              <TableRow key={index}>
                <TableCell>{action}</TableCell>
                <TableCell>{description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Typography variant='h6'>
          {texts.helpDialog.keyboardShortcuts}
        </Typography>
        <Table>
          <TableBody>
            {keyboardActions.map(([action, description], index) => (
              <TableRow key={index}>
                <TableCell>{action}</TableCell>
                <TableCell>{description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          {texts.helpDialog.closeButton}
        </Button>
      </DialogActions>
    </Dialog>
  )
);

HelpDialog.displayName = 'HelpDialog';
